import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

import Typography from "@mui/material/Typography";
import { Accordion } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import { ExpandMore as ExpandMoreIcon } from '@vedmarket/ui-kit';
import AccordionDetails from "@mui/material/AccordionDetails";

import {COLORS} from "../../../config/constants";

import NotificationText from "./components/notificationText";

import './demo-notification.scss'

type Props = {
  isAgreed: boolean;
  handleSetIsAgreed(value: boolean): void;
}

const DemoNotification = ({handleSetIsAgreed, isAgreed} : Props) => {

  const { t } = useTranslation()

  const [ expanded, setExpanded ] = useState(!isAgreed);

  useEffect(() => {
    setExpanded(!isAgreed);
  }, [ isAgreed ]);

  const onLogin = () => {
    setExpanded(false);
    handleSetIsAgreed(true);
  }

  return <div className='demo-notification'>
    <Accordion
      sx={{
        minWidth: 0,
        boxShadow: 'none',
        marginBottom: 0,
        '&.Mui-expanded': {
          marginBottom: 0
        }
      }}
      expanded={expanded}
      onChange={(e, isExpanded) => {
        if (isAgreed) setExpanded(isExpanded);
      }}>
      <AccordionSummary
        sx={{
          padding: 0,
          backgroundColor: COLORS.BLUE,
          justifyContent: 'flex-start',
          '.MuiAccordionSummary-content': {
            alignItems: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            flexGrow: 1,
            justifyContent: 'space-between',
            maxWidth: '1392px',
            width: 'calc(100% - 24px)',
            margin: '6px 12px',
          },
          '.Mui-expanded.MuiAccordionSummary-content': {
            margin: '6px 12px',
          },
          minHeight: '24px',
          '&.Mui-expanded': {
            borderBottom: 'none',
            minHeight: '24px',
          }
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className='demo-notification__summary-trigger'>
          <Typography variant='caption' gutterBottom sx={{
            textTransform: 'uppercase',
            fontWeight: 400,
            color: COLORS.WHITE,
            letterSpacing: '1px',
            cursor: 'pointer',
            marginBottom: 0,
          }}>
            {t('common__text__demo')}
          </Typography>
          <ExpandMoreIcon
            className={expanded
              ? 'demo-notification__expand-icon demo-notification__expand-icon_expanded'
              : 'demo-notification__expand-icon'}
          />
        </div>
        <div
          className='demo-notification__foundAnError'
          onClick={(event) => event.stopPropagation()}
        >
          <Typography variant='caption' gutterBottom sx={{
            textTransform: 'uppercase',
            fontWeight: 400,
            color: COLORS.WHITE,
            letterSpacing: '1px',
            cursor: 'pointer',
            marginBottom: 0,
          }}>
            {`${t('common__text__foundAnError')}? ${t('common__text__please')},`}&nbsp;
          </Typography>
          <Typography variant='caption' gutterBottom sx={{
            textTransform: 'uppercase',
            fontWeight: 400,
            color: COLORS.WHITE,
            letterSpacing: '1px',
            cursor: 'pointer',
            marginBottom: 0,
            borderBottom: '1px solid',
            lineHeight: 1,
          }}>
            <a href='mailto:demo@vedmarket.ru' className='demo-notification__link'>{`${t('common__text__letUsKnow')}`}</a>
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails sx={{
        backgroundColor: COLORS.BLUE,
        padding: '0px 24px',
        '.MuiAlert-standardInfo': {
          backgroundColor: `${COLORS.WHITE} !important`,
          color: `${COLORS.BLACK} !important`,
          padding: '0 0 0 16px',
        },
        '.MuiAlert-icon svg': {
          fill: `${COLORS.LIGHT_TEXT_SECONDARY} !important`,
          width: '24px',
          height: '24px',
        },
        '.MuiAlert-icon': {
          marginRight: '14px',
        },
        '.MuiStack-root': {
          maxWidth: '488px',
        },
        '.MuiAlert-action': {
          display: 'none',
        }
      }}>
        <NotificationText onLogin={onLogin}/>
      </AccordionDetails>
    </Accordion>
  </div>
};

export default DemoNotification
